import { useTranslation } from 'react-i18next';

import { StyledOverlay } from './style';
import { RedirectStatus } from '../../../../constants/enums';
import { ESdkEvents } from '../../../../contracts';
import { sendFEEvent } from '../../../../eventUtil';
import { mobileSDKUtils } from '../../../../utils/mobile-sdk-utils';
import { getSessionToken } from '../../../../utils/get-session-token';
import { getRedirectUrlWithEventParams } from '../../../../utils/url-utils';
import { isActiveSubscriptionError } from '../../../../utils/subscription-errors';

interface ScreenLockProps {
  header?: string;
  action: () => void;
  actionText: string;
  text?: string;
  isRedirect?: boolean;
}

const mobileSDKCheckoutStyle = mobileSDKUtils.getCheckoutStyle();

export function ScreenLock({ actionText, action, header, text, isRedirect }: ScreenLockProps) {
  const backgroundColor = mobileSDKCheckoutStyle.overlayBackgroundColor;
  return (
    <StyledOverlay backgroundColor={backgroundColor}>
      <h2>{header}</h2>
      <p>{text}</p>
      {isRedirect ? (
        <button
          className="redirect-button"
          style={{
            backgroundColor: 'white',
            color: 'black',
          }}
          onClick={action}
        >
          {actionText}
        </button>
      ) : (
        <button onClick={action}>{actionText}</button>
      )}
    </StyledOverlay>
  );
}

export function ErrorFallbackRender({ error, resetErrorBoundary }: any) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const redirectUrl = localStorage.getItem('redirectUrl') || '';

  const handleClose = () => {
    sendFEEvent(ESdkEvents.CLOSE_CHECKOUT, {
      reason: 'Error during fetch checkout data',
    });
  };

  // Extract error message - handle both Error objects and strings
  const errorMessage =
    error instanceof Error ? error?.message : typeof error === 'string' ? error : '';
  const header = isActiveSubscriptionError(error)
    ? t('activeSubscriptionAlreadyAvailableTitle')
    : t('somethingWentWrong');

  return (
    <ScreenLock
      header={header}
      action={() => {
        if (redirectUrl) {
          const sessionId = getSessionToken();
          localStorage.removeItem('redirectUrl');
          window.location.href = getRedirectUrlWithEventParams(redirectUrl, RedirectStatus.FAIL, {
            date: Date.now().toString(),
            ...(sessionId ? { sessionId } : {}),
          });
        } else {
          resetErrorBoundary();
          handleClose();
        }
      }}
      text={errorMessage}
      actionText={t('returnToGame')}
      isRedirect={!!redirectUrl}
    />
  );
}
